
import { call, takeLatest } from 'redux-saga/effects';
import {
  fetchAuditTrialList as fetchAuditTrailsList,
  fetchAuditBusinessProcesses,
} from '@api/auditTrials';
import { actions } from './auditFilters.slice';
import {
  AuditFiltersFetchAction,
  AuditBusinessProcessesFetchAction,
} from './auditFilters.types';
import { Resp, dispatch } from '../helpers';

export function* fetchAuditFiltersWorker({ payload }: AuditFiltersFetchAction) {
  try {
    const response: Resp<typeof fetchAuditTrailsList> = yield call(
      fetchAuditTrailsList,
      payload
    );
    const withPayloadData = response
      ? {
          ...response?.data,
          content: response.data.content,
          patientId: payload.patientId,
        }
      : undefined;

    yield dispatch(actions.fetchAuditTrialListSuccess(withPayloadData));
  } catch (error) {
    yield dispatch(actions.fetchAuditTrialListFailure(error as Error));
  }
}

export function* fetchBusinessProcessesWorker({ payload }: AuditBusinessProcessesFetchAction) {
  try {
    const response: Resp<typeof fetchAuditBusinessProcesses> = yield call(
      fetchAuditBusinessProcesses,
      payload.clinicalTrialId
    );

    yield dispatch(
      actions.fetchBusinessProcessesSuccess(response.data)
    );
  } catch (error) {
    yield dispatch(actions.fetchBusinessProcessesFailure(error));
  }
}

export function* auditFiltersSaga() {
  yield takeLatest(actions.fetchAuditTrailList.type, fetchAuditFiltersWorker);
  yield takeLatest(
    actions.fetchBusinessProcesses.type,
    fetchBusinessProcessesWorker
  );
}
